import React from 'react';
import { Text/*, Image*/, Rect } from 'react-konva';
import { isMobilePhone } from '../../library/calc';
import { fontFamily } from '../../library/constants';

const allLeft = 2.4;
const allTop = 3.1;
const circleDim = 7;

const openNewWindow = ({prId}) => {
  const href = '/inconsistencies/for_profile/' + prId;
  window.open(href, '_blank');
}

export class InconsistencyText extends React.Component {

  constructor(props){
    super(props);
    this.props.buildRefObj({key: `inconsistency_n-${this.props.node}`, objClass: this});
  }

  click(){

    openNewWindow({prId: this.props.pr_id})

  }

  render() {

      let killToolTip = false;

      let {
        left,
        top,
        cursorBecomesMove,
        cursorBecomesPointer,
        n,
        pr_id,
        showToolTipFor,
        hideToolTip,
        isPedigree,
        pedigreeIsTall,
        inc,
        userTouchedNode,
      } = this.props;


    if(n < 0) return null;

    let content = '';

    if( typeof(window.trl) !== 'undefined' ) content = window.trl('{count||Inconsistency}', 'profile action', {count: inc})

    left += -2.4;
    top += 1;

    const pedigreeTop = ( pedigreeIsTall ? 16: 8.4);
    top += ( !isPedigree ? 24.3: pedigreeTop);

    top += allTop;
    left += allLeft;

    return <Text
      x={left}
      y={top}
      text={'!'}
      fontSize={6}
      fontFamily={fontFamily}
      fill='white'
      onTouchStart={()=>{
        userTouchedNode({
          node:n,
          callback: ()=>{
            openNewWindow({prId: pr_id})
          },
          fromWhere: 'Inconsistency'
        });
      }}

      onClick={()=>{
        if(isMobilePhone() ) return;
        killToolTip = true;
        openNewWindow({prId: pr_id})
      }}

      onMouseover={()=>{
        cursorBecomesPointer();
        if(!killToolTip) {

          let shift = {};

          if(!isPedigree){
            shift = {
              left: -5,
              top: 0,
            }
          } else {
            if(pedigreeIsTall){
              shift = {
                left: -5,
                top: -9,
              }
            } else {
              shift = {
                left: -5,
                top: -13,
              }
            }
          }


          showToolTipFor({
            node: n,
            placement: 'under',
            shiftLeftOnToolTip: shift.left,
            shiftTopOnToolTip: shift.top,
            bubbleWidth: 30,
            content,
            runTranslatePhraseInToolTip: false,
          })
        }
      }}
      onMouseout={()=>{
        hideToolTip();
        cursorBecomesMove();
      }}

      onMouseenter={()=>{
        cursorBecomesPointer();
      }}

      onMouseleave={()=>{
        cursorBecomesMove();
      }}

    />;
  }
}



export class InconsistencyCircle extends React.Component {

  render () {
    let {
      n,
      left,
      top,
      isPedigree,
      pedigreeIsTall,
      cursorBecomesMove,
      cursorBecomesPointer,
    } = this.props;

    if(n < 0) return null;

    left += -5;
    top += .4;

    const pedigreeTop = ( pedigreeIsTall ? 15.7: 8);
    top += ( !isPedigree ? 24: pedigreeTop);

    top += allTop;
    left += allLeft;

    return  <Rect
              fill="#E96F20"
              x={left}
              y={top}
              width={circleDim}
              height={circleDim}
              cornerRadius={10}
              onMouseenter={()=>{
                cursorBecomesPointer();
              }}

              onMouseleave={()=>{
                cursorBecomesMove();
              }}
            />

  }
}


export class TransparentInconsistencyCircle extends React.Component {

  render () {
    let {
      n,
      pr_id,
      left,
      top,
      userTouchedNode,
      isPedigree,
      pedigreeIsTall,
      cursorBecomesPointer,
      cursorBecomesMove
    } = this.props;

    if(n < 0) return null;

    left += -5;
    top += .4;

    const pedigreeTop = ( pedigreeIsTall ? 15.7: 8);
    top += ( !isPedigree ? 24: pedigreeTop);

    top += allTop;
    left += allLeft;

    const wider = 2;
    /*

              fill="black"
              opacity={.5}
     */



    return  <Rect
              x={(left - wider / 2)}
              y={(top - wider / 2)}
              width={(circleDim + wider)}
              height={(circleDim + wider)}
              cornerRadius={10}
              onTouchStart={()=>{
                userTouchedNode({
                  node:n,
                  callback: ()=>{
                    openNewWindow({prId: pr_id})
                  },
                  fromWhere: 'TransparentInconsistencyCircle'
                });
              }}

              onMouseenter={()=>{
                cursorBecomesPointer();
              }}

              onMouseleave={()=>{
                cursorBecomesMove();
              }}

            />

  }
}
